module.exports = __webpack_public_path__ + "static/media/clarity-pitcher.578d44b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/clarity-pitcher.png
// module id = 77
// module chunks = 0